/* eslint-disable */
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import Reducers from './reducers'
import { createReduxHistoryContext } from 'redux-first-history'
// @ts-ignore
import { createBrowserHistory } from 'history'

type customWindow = {
  __REDUX_DEVTOOLS_EXTENSION__: any
} & Window &
  typeof globalThis

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createBrowserHistory(),
  })

// Combine the reducers to one state
const reducers = combineReducers({
  ...Reducers,
  router: routerReducer,
})

// Create the store
const store = createStore(
  reducers,
  // @ts-ignore
  compose(
    applyMiddleware(
      // Support thunked actions and react-router-redux
      thunk,
      routerMiddleware
    ) as any,
    // Support the Chrome DevTools extension
    (window as customWindow).__REDUX_DEVTOOLS_EXTENSION__
      ? (window as customWindow).__REDUX_DEVTOOLS_EXTENSION__()
      : (f: unknown) => f
  )
)

// this ts erros requires more refactoring
export const history = createReduxHistory(store)

export default store
